<template>
    <div class="text-center">
        <v-menu v-model="isMenuOpen" transition="slide-y-transition" bottom right offset-y :close-on-content-click="false" min-width="36%!important" max-width="60%" content-class="myprovet-menu-card">
            <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                    <v-text-field v-bind="{ ...obj.schema }" :value="display" readonly @click:clear="clearInput"> </v-text-field>
                </div>
            </template>

            <v-card class="myprovet-menu-card-inner-no-shadow" data-cy="navbar-client-menu" width="100%" height="200px">
                <v-card-title class="d-flex justify-center align-center">
                    <v-text-field
                        v-if="userStore.hasPermissionTo('Search branches by client_number')"
                        :value="searchBranchID"
                        type="number"
                        dense
                        solo
                        flat
                        :placeholder="$t('clientMenu.number')"
                        prepend-inner-icon="mdi-counter"
                        hide-details
                        height="40px"
                        :readonly="isLoading"
                        :background-color="isLoading ? 'rgb(200,200,200)' : '#F4F7FA'"
                        class="branch-selector-search-field font-size-sm input-bg-color-gray dark-gray-color mr-2 navbar-number  client-number-field"
                        :clearable="!isLoading"
                        @beforeinput="validateInput"
                        @input="checkIntegerNumber"
                    >
                        <template v-slot:append v-if="(searchBranchID && isLoading) || !searchBranchID">
                            <div class="branch-selector-append-padding"></div>
                        </template>
                    </v-text-field>

                    <v-text-field
                        v-if="userStore.hasPermissionTo('Search branches by name')"
                        v-model="searchBranchName"
                        dense
                        solo
                        flat
                        :placeholder="$t('clientMenu.name')"
                        prepend-inner-icon="mdi-rename-box"
                        hide-details
                        height="40px"
                        :readonly="isLoading"
                        :background-color="isLoading ? 'rgb(200,200,200)' : '#F4F7FA'"
                        class="branch-selector-search-field font-size-sm input-bg-color-gray dark-gray-color mr-2 name-field"
                        :clearable="!isLoading"
                        @input="resetShowingSelectedAndSearch(!searchBranchName)"
                    >
                        <template v-slot:append v-if="(searchBranchName && isLoading) || !searchBranchName">
                            <div class="branch-selector-append-padding"></div>
                        </template>
                    </v-text-field>

                    <v-text-field
                        v-if="userStore.hasPermissionTo('Search branches by taxpayer number')"
                        v-model="searchBranchTaxpayerNumber"
                        dense
                        solo
                        flat
                        :placeholder="$t('clientMenu.vat')"
                        prepend-inner-icon="mdi-circle-multiple-outline"
                        hide-details
                        height="40px"
                        :readonly="isLoading"
                        :background-color="isLoading ? 'rgb(200,200,200)' : '#F4F7FA'"
                        class="branch-selector-search-field font-size-sm input-bg-color-gray dark-gray-color taxpayer-field"
                        :clearable="!isLoading"
                        @input="resetShowingSelectedAndSearch(!searchBranchTaxpayerNumber)"
                    >
                        <template v-slot:append v-if="(searchBranchTaxpayerNumber && isLoading) || !searchBranchTaxpayerNumber">
                            <div class="branch-selector-append-padding"></div>
                        </template>
                    </v-text-field>
                </v-card-title>

                <v-card-text class="px-0" v-bind:class="{ 'myprovet-menu-card-scroll': isScrollable }">
                    <v-list flat>
                        <v-list-item-group>
                            <div ref="beginning"></div>

                            <template v-for="(item, index) in getGroupOfBranches">
                                <menu-item
                                    :key="index"
                                    :icon="item.children ? 'mdi-alpha-c' : getBranchIcon(item)"
                                    :parent="item.children ? true : false"
                                    :name="item.name"
                                    :orange="item.is_petfood && !item.children"
                                    :id="item.id"
                                    ref="branchMenuItems"
                                    :companyBranch="item.company_branch"
                                    :active="isActiveSelection(item)"
                                    @click="onBranchClicked(item)"
                                >
                                </menu-item>

                                <v-divider v-if="index < branches.length - 1" :key="`${index}-divider`" class="mx-4" style="border-color: rgba(196, 196, 196, 0.2)"></v-divider>

                                <template v-if="item.children">
                                    <div v-for="child in item.children" :key="child.client_number + '_child_' + child.company_branch">
                                        <menu-item class="pl-16" :icon="getBranchIcon(child)" :name="child.name" :orange="child.is_petfood && !child.children" :id="child.id" :companyBranch="child.company_branch" :active="isActiveSelection(child)" @click="onBranchClicked(child)"> </menu-item>

                                        <v-divider class="mx-4" style="border-color: rgba(196, 196, 196, 0.2)"></v-divider>
                                    </div>
                                </template>
                            </template>
                        </v-list-item-group>
                    </v-list>

                    <v-lazy v-if="!isLoading">
                        <div v-intersect="updatePagination"></div>
                    </v-lazy>

                    <div v-else class="text-center">
                        <v-progress-circular class="dark-blue-color" indeterminate></v-progress-circular>
                    </div>
                </v-card-text>

                <v-card-title class="d-flex justify-space-between py-0 branch-selector-bottom">
                    <v-checkbox dense :value="onlyShowingSelected" :input-value="onlyShowingSelected" :label="$t('clientMenu.onlySelected')" hide-details @click="toggleShowSelected" :disabled="disableShowSelectedBtn" :readonly="disableShowSelectedBtn"></v-checkbox>

                    <div class="navbar-clients-total-amount py-1">
                        <span class="dark-blue-color" style="font-size: 0.75rem">{{ $t('clientMenu.resultsCount', { shown: branches.length, total: totalResults }) }}</span>
                    </div>
                </v-card-title>

                <div class="branch-selector-padding"></div>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { useUserStore } from '@/Stores/user';
import { axios } from '@/Services/Backend';
import { buildQueryObjectFromModel } from '@arentia/atools/QueryBuilder';
import MenuItem from './VAppMultipleBranchSelectorItem.vue';

export default {
    props: ['type', 'value', 'obj'],

    components: {
        MenuItem,
    },

    data() {
        return {
            isMenuOpen: false,
            isScrollable: true,

            branches: [], // List of branches obtained from the endpoint

            selectedBranches: [], // Branches "enabled" on the filter
            selectedConsolidators: [], // Consolidators "enabled" on the filter

            menu: false,

            searchBranchID: null,
            searchBranchName: null,
            searchBranchTaxpayerNumber: null,

            onlyShowingSelected: true,

            page: 1,
            lastPage: 1,
            isLoading: false,
            totalResults: null,

            _timer: null,

            inertiaListener: null,
        };
    },

    created() {
        const data = this.obj?.schema?.dataPrefilledSelection;

        if (!data) {
            this.onlyShowingSelected = false;
        }

        this.clearLocalData();

        if (data && data.length > 0) {
            this.addConsolidatorIfNotSelected(data[0].client_number);

            data.forEach((entry) => this.addBranchIfNotSelected(entry));
        } else {
            this.onlyShowingSelected = false;
        }

        // @Note: nextTick to guarantee that this is done after the other events run.
        this.$nextTick(() => this.$emit('input', this.selectedBranches));

        this.getBranches();
    },

    mounted() {
        // @Note: beforeDestroy() seems to be firing after created() when browsing between 2 pages with this filter, .$on must be declared here
        window.EventBus.$on('clear-table-filters', () => {
            this.clearInput();

            this.onlyShowingSelected = false;
        });
    },

    beforeDestroy() {
        window.EventBus.$off('clear-table-filters');
    },

    watch: {
        isMenuOpen() {
            // We don't need to do anything when the menu opens, only when it closes.
            if (this.isMenuOpen) return;

            if (this.searchBranchID !== '' || this.searchBranchName !== '' || this.searchBranchTaxpayerNumber !== '') {
                // If the menu is closed and the client had a search, clear it.
                this.$nextTick(() => this.clearFilters());
            }

            // Scroll to the beginning of the list with a small delay to hide the change while the menu is closing.
            setTimeout(() => this.$refs?.beginning?.scrollIntoView(true), 200);
        },

        'branchStore.branch': {
            handler(newBranch, oldBranch) {
                if (newBranch && oldBranch && newBranch.id != oldBranch.id) location.reload();
            },
        },

        // @Note: Enabling this code will make the button be cleared but does not trigger a change to the full list of branches
        // 'selectedBranches.length': {
        //     handler(currentLength) {
        //         if (!currentLength) this.onlyShowingSelected = false;
        //     },
        // },
    },

    computed: {
        ...mapStores(useBranchStore, useUserStore),

        disableShowSelectedBtn() {
            return (this.selectedBranches.length == 0 && !this.onlyShowingSelected) || this.isLoading;
        },

        display() {
            if (this.selectedBranches?.length > 0) {
                return this.$tc('clientMenu.selectedCount', this.selectedBranches?.length, { n: this.selectedBranches?.length });
            }

            return null;
        },

        getGroupOfBranches() {
            if (this.branches.length === 0) return [];

            // If company A and B have an ID of e.g. '40' (they're different branches of the same company)
            // we want them to be grouped together with the main branch being the root node and the other branches the children nodes.
            const seenBranch = new Map();
            const result = [];

            for (const branch of this.branches) {
                if (seenBranch.has(branch.client_number)) continue;

                // Find all of the branches of the company.
                const branches = this.branches.filter((c) => c.client_number === branch.client_number);

                if (branches.length === 1) {
                    // Only one company branch (i.e. the main branch)
                    result.push(branch);
                } else {
                    // Multiple branches (i.e. add the consolidated company entry and all of the branches inside)
                    result.push({
                        name: this.$t('clientMenu.branchesOf', { name: branch.main_company_branch.name }),
                        clientNumber: branch.main_company_branch.client_number,
                        children: branches,
                    });
                }

                seenBranch.set(branch.client_number, true);
            }

            return result;
        },
    },

    methods: {
        toggleShowSelected() {
            if (this.disableShowSelectedBtn) {
                this.showWarning(this.$t('clientMenu.selectAtLeastOne'));
                return;
            }

            this.toggleShowingAll();
        },

        emitInput(event) {
            this.$emit('input', event?.trim() ?? '');
        },

        toggleShowingAll() {
            this.onlyShowingSelected = !this.onlyShowingSelected;
            this.clearFilters(true, true);
        },

        clearInput() {
            const refreshList = this.onlyShowingSelected;

            this.onlyShowingSelected = false;
            this.$emit('input', []);
            this.clearLocalData();

            if (refreshList) this.getBranches(true);
        },

        clearLocalData() {
            this.selectedBranches = [];
            this.selectedConsolidators = [];
        },

        getBranchIcon(branch) {
            if (!branch) return '';
            return branch.is_petfood ? 'mdi-alpha-p' : 'mdi-alpha-f';
        },

        isActiveSelection(item) {
            if (item.clientNumber && item.children) {
                // This is a consolidator
                return this.selectedConsolidators.indexOf(item.clientNumber) > -1;
            }

            return this.selectedBranches.map((i) => i.id).indexOf(item.id) > -1;
        },

        async onBranchClicked(item) {
            if (item?.children) {
                const index = this.selectedConsolidators.indexOf(item.clientNumber);
                const hasConsolidated = index !== -1;

                if (hasConsolidated) {
                    // Branch found, meaning the user wants to remove it from the selection
                    this.selectedConsolidators.splice(index, 1);
                } else {
                    // Branch not in the list, adding it to the selection
                    this.selectedConsolidators.push(item.clientNumber);
                }

                // This is a consolidator item, so now we'll get the full list of children (they might not be fully loaded yet due to pagination) and possibly change their status
                await axios
                    .get(`/api/branches/selector/consolidator-branches/${item.clientNumber}`)
                    .then(({ data: branches }) => branches.forEach((branch) => this.toggleSelection(branch, true, !hasConsolidated)))
                    .catch(() => this.showWarning(this.$t('clientMenu.consolidatedError')));
            } else {
                this.toggleSelection(item);
            }

            this.$emit('input', this.selectedBranches);
        },

        toggleSelection(branch, fromParent = false, targetStatus = false) {
            const index = this.selectedBranches.map((i) => i.id).indexOf(branch.id);

            if (fromParent) {
                if (index < 0 && targetStatus == true) {
                    this.addBranchToSelection(branch);
                } else if (targetStatus == false) {
                    this.removeBranchFromSelection(branch, index);
                }
                return;
            }

            if (index < 0) {
                this.addBranchToSelection(branch);
            } else {
                this.removeBranchFromSelection(branch, index);
            }
        },

        addBranchToSelection(branch) {
            this.selectedBranches.push({ id: branch.id });
        },

        addBranchIfNotSelected(branch) {
            const index = this.selectedBranches.map((i) => i.id).indexOf(branch.id);
            if (index >= 0) return;

            this.selectedBranches.push({ id: branch.id });
        },

        addConsolidatorIfNotSelected(clientNumber) {
            if (!clientNumber === undefined) return;

            const index = this.selectedConsolidators.indexOf(clientNumber);
            if (index >= 0) return;

            this.selectedConsolidators.push(clientNumber);
        },

        removeBranchFromSelection(branch, index) {
            // Remove this branch from the selection (possibly due to its parent's status)
            this.selectedBranches.splice(index, 1);

            // Set the parent to inactive (if active)
            const parentIndex = this.selectedConsolidators.indexOf(branch.client_number);
            if (parentIndex > -1) {
                this.selectedConsolidators.splice(parentIndex, 1);
            }
        },

        clearFilters(skipDebounce = true, resetBranches = false) {
            this.searchBranchID = null;
            this.searchBranchName = null;
            this.searchBranchTaxpayerNumber = null;

            this.search(skipDebounce, resetBranches); // true: skip debounce, reset branches list
        },

        getBranches(resetBranches = false) {
            this.isLoading = true;

            const schema = {
                id: { dataFieldOperator: 'begins_with' },
                name: { dataFieldOperator: 'keywords' },
                taxpayer_number: { dataFieldOperator: 'contains' },
            };

            const search = { id: this.searchBranchID, name: this.searchBranchName, taxpayer_number: this.searchBranchTaxpayerNumber };
            const query = JSON.stringify(buildQueryObjectFromModel(search, schema));

            if (resetBranches) {
                this.$refs.beginning?.scrollIntoView(true);
                this.page = 1;
            }

            const endpoint = this.onlyShowingSelected ? `/api/branches/selector/search-selected?page=${this.page}&queryObject=${query}` : `/api/branches/selector/search?page=${this.page}&queryObject=${query}`;
            const params = this.onlyShowingSelected ? { selected_branches: this.selectedBranches.map((branch) => branch.id) } : null;

            return axios
                .get(endpoint, { params: params })
                .then((response) => {
                    this.isLoading = false;
                    this.page = response.data.meta.current_page;
                    this.lastPage = response.data.meta.last_page;
                    this.totalResults = response.data.meta.total;

                    if (resetBranches) this.branches = []; // The "show only selected / show all again" button was pressed, clearing the list first
                    this.branches = [...this.branches, ...response.data.data];
                })
                .catch((error) => {
                    this.isLoading = false;

                    console.log(error);
                });
        },

        checkIntegerNumber(value) {
            if (value) {
                value = parseInt(value);
                if (!Number.isInteger(value)) return;
            }

            this.searchBranchID = value;
            this.resetShowingSelectedAndSearch(!value);
        },

        resetShowingSelectedAndSearch(skipDebounce, resetBranches = false) {
            if (this.onlyShowingSelected) this.onlyShowingSelected = false; // Toggle this off when starting a new search
            this.search(skipDebounce, resetBranches);
        },

        search(skipDebounce, resetBranches = false) {
            this.branches = [];
            this.page = 1;
            this.lastPage = 1;

            // Debounce the search - it will prevent errors when updating too quickly.
            clearTimeout(this._timer);

            this._timer = setTimeout(
                () => {
                    this.isLoading = true;
                    this.getBranches(resetBranches);
                },
                skipDebounce ? 0 : 1000
            );
        },

        updatePagination() {
            if (this.isLoading || this.page >= this.lastPage) return;

            this.page += 1;
            this.getBranches();
        },
    },
};
</script>

<style scoped>
.branch-selector-padding {
    float: right; /* without this, the container collapses */
}
</style>

<style>
.myprovet-menu-card-inner-no-shadow {
    box-shadow: none !important;
}

.branch-selector-search-field {
    border-radius: 8px;
    width: 238px;
    min-width: 238px;
}
</style>
